import { Controller } from "@hotwired/stimulus"

// Live preview for the book cover upload. Reads the picked file with
// FileReader and swaps the placeholder/old image with the new one before
// the form is saved.
//
// Targets:
//   input       — the hidden file_field
//   placeholder — the icon block shown when no image is attached
//   image       — the <img> shown when an image is attached (may not exist on first load)
//   title       — the "Ajouter une couverture" / "Couverture actuelle" label
//   hint        — the small hint line under the title
//   container   — the box that holds either the placeholder or the image (used to mount a new <img>)
export default class extends Controller {
  static targets = ["input", "placeholder", "image", "title", "hint", "container"]

  preview() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const url = e.target.result // safe: data: URL produced by FileReader

      if (this.hasImageTarget) {
        this.imageTarget.src = url
      } else if (this.hasContainerTarget) {
        // Replace the placeholder icon with a fresh <img>. Built via DOM APIs
        // (no innerHTML) so the only attacker-controllable value is the data:
        // URL from FileReader, which can't carry script.
        const img = document.createElement("img")
        img.src = url
        img.alt = ""
        img.style.width = "72px"
        img.style.height = "72px"
        img.style.objectFit = "cover"
        img.style.borderRadius = "10px"
        img.style.flexShrink = "0"
        img.style.border = "1px solid var(--line)"
        img.setAttribute("data-book-cover-preview-target", "image")

        this.containerTarget.replaceChildren(img)
      }

      if (this.hasTitleTarget) {
        this.titleTarget.textContent = "Nouvelle couverture · prête à enregistrer"
      }
      if (this.hasHintTarget) {
        const sizeKb = Math.round(file.size / 1024)
        this.hintTarget.textContent = `${file.name} · ${sizeKb} KB · cliquez pour changer`
      }
    }
    reader.readAsDataURL(file)
  }
}
